//helpers
import { CheckboxList } from 'thrive-components';
import { removeSpaces } from  '@/helpers/Text';

//hooks
import UseFeedFilters from './FeedFilters.hooks';
  


const PopOutFeedFilter = () => {
    const {feedFilters, popoutClassname} = UseFeedFilters();

    return (    
        <div className='pop-out-feed-filter'>
            {feedFilters.map((filterGroup) => (
                filterGroup.items.length
                    ?   <CheckboxList 
                            key={removeSpaces(`${filterGroup.infoTitle}-popout`)} 
                            items={filterGroup.items} 
                            title={filterGroup.infoTitle} 
                            className={popoutClassname}
                        />
                    :   undefined
                )).filter((filterGroup) => filterGroup)
            }
        </div>
    );
};
export default PopOutFeedFilter